
import item1 from '../assets/contact/item1.svg';
import item2 from '../assets/contact/item2.svg';
import item3 from '../assets/contact/item3.svg';
import item4 from '../assets/contact/item4.svg';

import { getContent } from '../store/ContentStore';

const ICON_MAP = {
    item1: item1,
    item2: item2,
    item3: item3,
    item4: item4,
};

const MAX_CONTACT_ITEMS = Object.keys(ICON_MAP).length; 

export const loadContactContentEn = () => {
    const contactData = getContent("contact.", "en");

    if (!contactData || !contactData.en || Object.keys(contactData.en).length === 0) {
        return { title: '', subtitle: '', description: '', contact: [] };
    }
    
    const englishLabels = contactData.en; 
   
    const mainTitle = englishLabels['contact.title'] || 'Default Contact Title';
    const mainSubtitle = englishLabels['contact.subtitle'] || 'Default Contact Subtitle';
    const mainDescription = englishLabels['contact.description'] || 'Default Contact Description';

    const contactArray = [];

    for (let i = 1; i <= MAX_CONTACT_ITEMS; i++) {
        const itemKey = `item${i}`; 
        
        const headingKey = `contact.${itemKey}.title`;
        const descriptionKey = `contact.${itemKey}.description`;
        
        const heading = englishLabels[headingKey];
        const description = englishLabels[descriptionKey];
        const icon = ICON_MAP[itemKey];

        if (heading && description && icon) {
            contactArray.push({
                icon: icon,
                heading: heading,
                description: description,
            });
        }
    }
    
    return {
        title: mainTitle,
        subtitle: mainSubtitle,
        description: mainDescription,
        contact: contactArray,
    };
};


export const loadContactContentRo = () => {
    const contactData = getContent("contact.", "ro");

    if (!contactData || !contactData.ro || Object.keys(contactData.ro).length === 0) {
        return { title: '', subtitle: '', description: '', contact: [] };
    }
    
    const romanianLabels = contactData.ro; 
   
    const mainTitle = romanianLabels['contact.title'] || 'Default Contact Title';
    const mainSubtitle = romanianLabels['contact.subtitle'] || 'Default Contact Subtitle';
    const mainDescription = romanianLabels['contact.description'] || 'Default Contact Description';

    const contactArray = [];

    for (let i = 1; i <= MAX_CONTACT_ITEMS; i++) {
        const itemKey = `item${i}`; 
        
        const headingKey = `contact.${itemKey}.title`;
        const descriptionKey = `contact.${itemKey}.description`;
        
        const heading = romanianLabels[headingKey];
        const description = romanianLabels[descriptionKey];
        const icon = ICON_MAP[itemKey];

        if (heading && description && icon) {
            contactArray.push({
                icon: icon,
                heading: heading,
                description: description,
            });
        }
    }
    
    return {
        title: mainTitle,
        subtitle: mainSubtitle,
        description: mainDescription,
        contact: contactArray,
    };
};